import * as React from "react";
import { Link as BrowserLink, useNavigate } from "react-router-dom";
import { ProjectObject } from "../../types";
import styles from "./ProjectListRow.module.css";
import { useTranslation } from "react-i18next";

//MaterialUI
import {
  Link,
  TableBody,
  TableCell,
  Typography,
  TableRow,
  Tooltip,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/IconButton";

const AllCompanyProjectsListRow = (props: { row: ProjectObject }) => {
  const navigateToLink = useNavigate();
  const { row } = props;

  const { t } = useTranslation();

  const openMap = (project: ProjectObject) => {
    const apiUrl = "https://www.google.com/maps/search/?api=1&query="; //centurylink+field";
    let query = project.address1+ " ";
    query +=
      project.address2 !== undefined && project.address2 !== ""
        ? project.address2
        : "";
    query += " " + project.postalCode;
    query += " " + project.city;

    query = query.replaceAll(" ", "+");

    window.open(apiUrl + query, "_blank");
  };

  const openProjectSettings = (project: ProjectObject) => {
    ///projects/4/projectsettings/info
    navigateToLink(`${project.id}/projectsettings/info`);
  };

  return (
    <TableBody>
      <TableRow hover key={"projectrow_" + row.name + row.id}>
        <TableCell component="th" scope="row" className={styles["projects-table-project-cell"]}>
          <div>
            <BrowserLink
              to={`/projects/${row.id}/load`}
              className={styles["projects-table-project-link"]}
            >
              <Link
                component="button"
                variant="body1"
                underline="always"
                sx={{ fontSize: "var(--navButtonFontSize)", textAlign: "left !important", mr: "5px" }}
              >
                {row.name}
              </Link>
            </BrowserLink>
            {row.status === 4 ? (
              <Typography variant="subtitle2" sx={{ display: "block", marginTop: "2px" }}>
                {t("common.archived")}
              </Typography>
              ) : null}
            </div>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          align="right"
          className={styles["projects-table-address-cell"]}
        >
          <Typography
            sx={{ fontSize: "var(--navButtonFontSize)" }}
            variant="body1"
            component="span"
          >{`${row.address1}${row.address2 ? `, ${row.address2}` : ""}, ${row.postalCode} ${
            row.city
          }`}</Typography>
        </TableCell>
        <TableCell className={styles["projects-table-map-cell"]} size="small" align="right">
          <Tooltip title={t("tooltip.show_on_map") || ""}>
            <IconButton size="small" onClick={() => openMap(row)} aria-label="map">
              <MapIcon
                sx={{
                  color: "var(--colorOrange)",
                  height: "var(--iconSize)",
                  width: "var(--iconSize)"
                }}
              />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell className={styles["projects-table-edit-cell"]} size="small" align="right">
          <Tooltip title={t("tooltip.settings") || ""}>
            <IconButton size="small" onClick={() => openProjectSettings(row)} aria-label="settings">
              <SettingsIcon
                sx={{
                  color: "var(--colorOrange)",
                  height: "var(--iconSize)",
                  width: "var(--iconSize)"
                }}
              />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}

export default AllCompanyProjectsListRow;
